import { buttonCompoundVariants, buttonDefaultVariants, buttonDisabledVariants, buttonDropShadowVariants, buttonEmphasisVariants, buttonFullWidthVariants, buttonShadowVariants, buttonSizeVariants, buttonSlots, buttonTypeVariants } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const aVariants = tv({
    slots: {
        ...buttonSlots,
        buttonSlot: `${buttonSlots.buttonSlot} inline-flex`
    },
    variants: {
        type: buttonTypeVariants,
        size: buttonSizeVariants,
        emphasis: buttonEmphasisVariants,
        fullWidth: {
            true: {
                ...buttonFullWidthVariants["true"],
                wrapperSlot: 'w-full'
            }
        },
        shadow: buttonShadowVariants,
        dropShadow: buttonDropShadowVariants,
        disabled: buttonDisabledVariants,
        variant: {
            standalone: 'hover:underline',
            inline: 'underline hover:underline'
        },
        active: {
            true: ''
        }
    },
    compoundVariants: [
        ...buttonCompoundVariants,
        {
            type: 'primary',
            active: true,
            class: 'text-actionPrimary-12'
        },
        {
            type: 'secondary',
            active: true,
            class: 'text-actionSecondary-12'
        }
    ],
    defaultVariants: {
        ...buttonDefaultVariants,
        variant: 'standalone'
    }
});
export { aVariants };
